<template>
    <div :style="`display:block;height:${size}px;`">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 45 64" fill="#fff" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round">
            <use xlink:href="#A" x=".5" y=".5"/>
            <symbol id="A" overflow="visible">
                <path d="M17.52 18.443c0-2.66 2.25-3.7 5.88-3.7 6.02.13 11.92 1.63 17.25 4.4V3.103A46.6 46.6 0 0 0 23.4.003C9.4.003 0 7.203 0 19.243c0 18.82 26.33 15.77 26.33 23.88 0 3.17-2.77 4.16-6.65 4.16-5.74 0-13.14-2.33-18.95-5.43v16.23c5.98 2.56 12.43 3.9 18.95 3.92 14.4 0 24.32-6.98 24.32-19.23 0-20.3-26.48-16.68-26.48-24.33"
                      :stroke="`${stroke}`"
                      :fill="`${fill}`"
                      :stroke-width="`${strokewidth}`"
                />
            </symbol>
        </svg>
    </div>
</template>

<script>
  export default {
    props: {
      fill: {
        type: String,
        required: false,
        default: 'rgba(0,0,0,.54)'
      },
      stroke: {
        type: String,
        required: false,
        default: 'none'
      },
      strokewidth:{
        type: String,
        required: false,
        default: '1'
      },
      size: {
        type: String,
        required: false,
        default: '24'
      }
    },
    components: {},
    name: "Stripe",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>